import RestService from './rest.service';

export default RestService;